module.exports = __webpack_public_path__ + "img/262-1.9d4e1ad3.png";